module.exports = __webpack_public_path__ + "static/media/gibson-bold.2c190afb.eot";